'use client';

import { useMediaQuery } from '@shared/shared-utils';
import { VideoThoughtsCarousel } from '../video-thoughts-carousel/video-thoughts-carousel';
import { VideoThoughtsCarouselMobile } from '../video-thoughts-carousel-mobile/video-thoughts-carousel-mobile';

const HCPThoughtsCarousel = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)');

  return isMobile ? <VideoThoughtsCarouselMobile /> : <VideoThoughtsCarousel />;
};

export { HCPThoughtsCarousel };
